import { useEffect, useState } from 'react';
import * as Sqrl from 'squirrelly';
import parse from 'html-react-parser';
import getParserOptions from '../options';
//import LoadingSpinner from '../../../utils/LoadingSpinner';
//import CompilationError from '../../500';

import {
  getAuth,
  isSignInWithEmailLink,
  signInWithEmailLink
} from 'firebase/auth';
import { keyUpdatedAction } from '../../../redux/actions/local';
import { useDispatch } from 'react-redux';
import usePage from '../../../hooks/page';
import { consoleLog } from '../../../utils/Logger';
import { initFlowbite } from 'flowbite';

const NotAuthenticatedPublicPage = props => {
  const {
    siteMapPage,
    sequencer: { execute, run }
  } = props;

  const dispatch = useDispatch();
  const { page, html, data, ready } = usePage({
    siteMapPage,
    isPublicPage: true
  });

  const [parsedHtml, setParsedHtml] = useState();
  const [hasError, setHasError] = useState(false);

  if (data?.local?.logData) {
    console.log({ data });
  }

  consoleLog('NotAuthenticatedPublicPage', {
    name: page?.name,
    id: page?.id,
    data,
    ready
  });

  /* the action sequencer that will be used on the page */
  window.actionSequencer = {
    execute,
    run,
    page
  };

  useEffect(() => {
    // Confirm the link is a sign-in with email link.
    const auth = getAuth();
    if (isSignInWithEmailLink(auth, window.location.href)) {
      dispatch(
        keyUpdatedAction('passwordLessLogin', {
          inProgress: true,
          askForEmail: false
        })
      );

      // Additional state parameters can also be passed via URL.
      // This can be used to continue the user's intended action before triggering
      // the sign-in operation.
      // Get the email if available. This should be available if the user completes
      // the flow on the same device where they started it.
      let email = window.localStorage.getItem('emailForSignIn');

      if (!email) {
        if (data.local?.passwordLessLogin.email) {
          email = data.local?.passwordLessLogin.email;
        }
      }

      if (!email) {
        // User opened the link on a different device. To prevent session fixation
        // attacks, ask the user to provide the associated email again. For example:
        //email = window.prompt('Please provide your email for confirmation');
        dispatch(
          keyUpdatedAction('passwordLessLogin', {
            askForEmail: true,
            code: window.location.href
          })
        );
        return;
      } else {
        // The client SDK will parse the code from the link for you.
        signInWithEmailLink(auth, email, window.location.href)
          .then(result => {
            // Clear email from storage.
            window.localStorage.removeItem('emailForSignIn');
            dispatch(
              keyUpdatedAction('passwordLessLogin', {
                askForEmail: false,
                inProgress: false,
                result
              })
            );
            // You can access the new user via result.user
            // Additional user info profile not available via:
            // result.additionalUserInfo.profile == null
            // You can check if the user is new or existing:
            // result.additionalUserInfo.isNewUser
          })
          .catch(error => {
            // Some error occurred, you can inspect the code: error.code
            // Common errors could be invalid email and invalid or expired OTPs.
            dispatch(
              keyUpdatedAction('passwordLessLogin', {
                inProgress: false,
                error
              })
            );
          });
      }
    }
  }, []);

  useEffect(() => {
    if (ready) {
      let theHtml = html;
      try {
        theHtml = parse(
          Sqrl.render(html, data),
          getParserOptions({
            page,
            data
          })
        );
        setParsedHtml(theHtml);
      } catch (err) {
        console.log('NotAuthenticatedPublicPage.error', {
          err,
          html: data?.local?.logData ? html : 'redacted'
        });
        setHasError(err);
      }
    }
  }, [ready, page, data, html]);

  useEffect(() => {
    if (parsedHtml) {
      initFlowbite();
    }
  }, [parsedHtml]);

  if (!ready) {
    return null;
    //return <LoadingSpinner footertext="Please wait..." />;
  }

  if (hasError) {
    //return <CompilationError error={hasError} page={page} />;
  }

  return (
    <>
      {page?.css?.trim().length > 0 ? (
        <style type="text/css">{page.css}</style>
      ) : null}
      {parsedHtml}
    </>
  );
};

export default NotAuthenticatedPublicPage;
